import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=2a7a1a6a&scoped=true&"
import script from "./PlanForm.vue?vue&type=script&lang=js&"
export * from "./PlanForm.vue?vue&type=script&lang=js&"
import style0 from "./PlanForm.vue?vue&type=style&index=0&id=2a7a1a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a1a6a",
  null
  
)

export default component.exports